"use client";

import { useEffect } from "react";
import { useAppDispatch } from "@/lib/redux/root";
import { setBrandConfig, setProduct } from "@/lib/redux/slices/brand.slice";
import { getBrandConfig } from "@/lib/brand-config";

interface BrandInitializerProps {
	product: string;
}

export function BrandInitializer({ product }: BrandInitializerProps) {
	const dispatch = useAppDispatch();

	useEffect(() => {
		const brandConfig = getBrandConfig(product);
		dispatch(setBrandConfig(brandConfig));
		dispatch(setProduct(product));
	}, [product, dispatch]);

	return null;
}
